import { useEffect, useState } from 'react';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { ProgressSpinner } from 'primereact/progressspinner';
import { getPendingPreLiqItemsForBillingEntity } from '../../servicesHooks/Honorarium/useHonorariumPreLiquidationService';
import { HonorariumPreLiquidationItemDTO } from '../../dto/HonorariumPreLiquidationDTO';
import { parseApiError } from '../../services/apiError';
import { formatMoney } from '../../utils/money';
import { formatDateOnly } from '../../utils/date';
import useNotify from '../../hooks/useNotify';

interface PendingPreLiquidationItemsProps {
    billingEntityId: number;
    professionalId: number;
}

/** Ítems de pre-liquidación pendientes de un profesional, dentro de su fila desplegada (solo lectura). */
export default function PendingPreLiquidationItems({ billingEntityId, professionalId }: PendingPreLiquidationItemsProps) {
    const notify = useNotify();
    const [items, setItems] = useState<HonorariumPreLiquidationItemDTO[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let cancelled = false;
        setLoading(true);
        getPendingPreLiqItemsForBillingEntity(billingEntityId, professionalId)
            .then(data => { if (!cancelled) setItems(data ?? []); })
            .catch((error: unknown) => {
                parseApiError(error); // loguea errorCode y path para cruzarlo con el backend
                if (!cancelled) notify.error('No se pudieron cargar los ítems pendientes. Intentá de nuevo.');
            })
            .finally(() => { if (!cancelled) setLoading(false); });
        return () => { cancelled = true; };
    }, [billingEntityId, professionalId, notify]);

    if (loading) {
        return (
            <div className="md-loading" role="status">
                <ProgressSpinner strokeWidth="4" />
                <span>Cargando…</span>
            </div>
        );
    }

    return (
        <div className="honorarium-liquidation__expansion">
            <DataTable value={items} dataKey="honorariumPreLiquidationItem" className="crudTable" emptyMessage="Sin ítems pendientes.">
                <Column field="sourceType" header="Origen" />
                <Column
                    header="Período"
                    body={(row: HonorariumPreLiquidationItemDTO) => `${formatDateOnly(row.fromDate)} – ${formatDateOnly(row.toDate)}`}
                />
                <Column field="detailCount" header="Registros" className="text-center" headerClassName="col-center" />
                <Column
                    header="Honorario profesional"
                    body={(row: HonorariumPreLiquidationItemDTO) => formatMoney(row.professionalAmount)}
                    className="text-right"
                    headerClassName="col-right"
                />
            </DataTable>
        </div>
    );
}
